"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CodeFromMailForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _reactI18next = require("react-i18next");
var _reactHookForm = require("react-hook-form");
var _yup = require("@hookform/resolvers/yup");
var yup = _interopRequireWildcard(require("yup"));
var _ui = require("../../ui");
var _validations = require("../../../validations");
var _fields = require("../../fields");
var _form = require("../form");
var _TimerTextButton = require("../../TimerTextButton");
var _templateObject, _templateObject2;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Description = (0, _styledComponents.default)(_ui.P)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
});
var LabelWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
var schema = yup.object().shape({
  code: _validations.numericalValidation.length(6).required()
}).required();
var CodeFromMailForm = function CodeFromMailForm(_ref2) {
  var onSubmit = _ref2.onSubmit,
    contactSupportLink = _ref2.contactSupportLink,
    sendTimeout = _ref2.sendTimeout,
    send = _ref2.send,
    sendLoading = _ref2.sendLoading;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libAuth', 'libCommon', 'libSettings']),
    t = _useTranslation.t;
  var _useForm = (0, _reactHookForm.useForm)({
      resolver: (0, _yup.yupResolver)(schema)
    }),
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(LabelWrapper, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('libAuth:codeFromEmail')), /*#__PURE__*/_react.default.createElement(_TimerTextButton.TimerTextButton, {
    afterTimeoutClick: send,
    timeout: sendTimeout,
    label: t('libAuth:resendCode'),
    loading: sendLoading
  })), /*#__PURE__*/_react.default.createElement(_fields.InputField, {
    control: control,
    inputProps: {
      name: 'code',
      type: 'number',
      placeholder: t('libSettings:your6DigitCode')
    }
  })), /*#__PURE__*/_react.default.createElement(Description, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "libAuth:verifyFormDescription"
  }, /*#__PURE__*/_react.default.createElement(_ui.MediumSpan, null), /*#__PURE__*/_react.default.createElement(_ui.MediumSpan, null), /*#__PURE__*/_react.default.createElement(_ui.Link, {
    target: "_blank",
    href: contactSupportLink
  }))), /*#__PURE__*/_react.default.createElement(_form.FormButton, {
    color: "secondary"
  }, t('libCommon:continue')));
};
exports.CodeFromMailForm = CodeFromMailForm;